import type { OrderInfo } from '@@partner:types:app'

import React, { useEffect, useState } from 'react'
import { useOrderPromocodeInfo } from '@@partner:helpers/hooks/useOrderPromocodeInfo'

import { Tag } from 'rsuite'
import OrderTotalInfo from './OrderTotalInfo'
import AppLoader from '@components/common/AppLoader'
import InlinePromocode from '../promocode/InlinePromocode'
import OrderMinCostInfo from './OrderMinCostInfo'

import './OrderCost.scss'

export interface OrderCostProps {
  order: OrderInfo
  loading?: boolean
  readOnly?: boolean
}
export default function OrderCost ({
  order,
  readOnly = false,
  loading = false
}: OrderCostProps) {
  const {
    promocode,
    refetch,
    canRefetch,
    loading: loadingPromocode
  } = useOrderPromocodeInfo(order.id, order.promocode?.id)

  const [ loadingCosts, setLoadingCosts ] = useState(loading || loadingPromocode)

  useEffect(() => {
    if (canRefetch) {
      setLoadingCosts(true)
      refetch().finally(() => setLoadingCosts(() => loading))
    }
  }, [ loading, order, refetch, canRefetch ])

  return (
    <div className="OrderCost">
      {loadingCosts && <AppLoader.Inner content="Расчёт" size="md" />}

      {!readOnly && order.shop && (
        <OrderMinCostInfo
          cost={order.total}
          minCost={order.shop?.minOrderCost}
        />
      )}

      {!readOnly && (
        <InlinePromocode
          order_id={order.id}
          promocode_id={order.promocode?.id}
          promocode={order.promocode?.code}
        />
      )}

      <div className="OrderCost__Totals">
        <div className="OrderCost__TotalsRow">
          <strong>
            <span>🛒</span> Стоимость товаров:
          </strong>

          <OrderTotalInfo
            showPercent
            total={order.assembledOrderTotal > 0 ? order.assembledOrderTotal : order.total}
            saleInfo={promocode?.total}
          />
        </div>
        { order.assembledOrderTotal > 0 && order.assembledOrderTotal !== order.total ? (
          <div className="OrderCost__TotalsRow">
            <span>🛒</span> Заказано:

            <OrderTotalInfo
              showPercent={false}
              total={order.total}
              saleInfo={promocode?.total}
            />
          </div>
        ) : <div></div>}
        <div className="OrderCost__TotalsRow">
          <strong>
            <span>🚚</span> Стоимость доставки:
          </strong>
          <OrderTotalInfo
            showPercent
            total={order.delivery_total}
            saleInfo={promocode?.delivery}
          />
        </div>

        {order.promocode?.code && (
          <Tag className="OrderCost__Promocode" color="violet">
            Применяется промокод: {order.promocode.code}{' '}
          </Tag>
        )}
        <div className="OrderCost__TotalsRow OrderCost__TotalsRow--highlight">
          <strong>
            <span>🦄</span> Общая стоимость заказа (после сборки)
          </strong>
          <OrderTotalInfo
            showTotal
            total={order.assembledOrderTotal + order.delivery_total}
          />
          &nbsp;

          <span>(начислено бонусов <strong>{order.totalCashback ?? 0})</strong></span>

        </div>
        <div className="OrderCost__TotalsRow OrderCost__TotalsRow--highlight">
          <span></span> Общая стоимость заказа (до сборки)

          <OrderTotalInfo
            showTotal
            total={order.totalCost}
            saleInfo={{
              sale:
                (promocode?.total?.sale ?? 0) + (promocode?.delivery?.sale ?? 0)
            }}
          />

        </div>
      </div>
    </div>
  )
}
